import { useStore } from 'zustand'

import type { PartnerProfile } from '@/store'
import { store } from '@/store'

const ADMIN_ROLES = new Set(['MANAGER', 'ADMIN'])

export const hasAdminRole = (partner: Pick<PartnerProfile, 'role'> | null): boolean =>
  partner !== null && ADMIN_ROLES.has(partner.role)

export const useIsAdmin = () => {
  const partner = useStore(store, (s) => s.partner)

  return hasAdminRole(partner)
}

export const isAdmin = () => hasAdminRole(store.getState().partner)
